module.exports = "<p>\n  deliverycmd works!\n</p>\n"